import { ProbabilityShareType } from '../enums/probability-share-type.enum';
import { interpolateTemplate } from '../utils/interpolate-template.util';

/** Tokenized templates — single source for admin defaults + runtime share text. */
export const PROBABILITY_SHARE_TEXT_TEMPLATES: Record<ProbabilityShareType, string> = {
	[ProbabilityShareType.EVENT]:
		'Think your sports takes are sharp?\n\nJoin the Probability Cup on SportsPredict and see if you can beat the crowd.',
	[ProbabilityShareType.LOCKED_IN]:
		'I just locked in a {probability}% forecast for the question "{question}".\n\nCan you beat my read on the game?',
	[ProbabilityShareType.MATCH_RESULTS]:
		'I pulled in a total score of {rbp} in the {matchName} match!\n\nCan you do better? Come play:',
	[ProbabilityShareType.RANK]:
		"I'm ranked #{rank} in the SportsPredict leaderboard.\n\nCome take my spot if you can:",
	[ProbabilityShareType.PROFILE]:
		"I've logged a total of {count} predictions, ranked #{rank} globally.\n\nCatch up and start forecasting here:",
};

export interface ProbabilityShareText {
	description: (params: Record<string, string>) => string;
}

export const PROBABILITY_SHARE_TEXTS: Record<ProbabilityShareType, ProbabilityShareText> = {
	[ProbabilityShareType.EVENT]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.EVENT], params),
	},
	[ProbabilityShareType.MATCH_RESULTS]: {
		description: (params) =>
			interpolateTemplate(
				PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.MATCH_RESULTS],
				params
			),
	},
	[ProbabilityShareType.PROFILE]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.PROFILE], params),
	},
	[ProbabilityShareType.RANK]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.RANK], params),
	},
	[ProbabilityShareType.LOCKED_IN]: {
		description: (params) =>
			interpolateTemplate(PROBABILITY_SHARE_TEXT_TEMPLATES[ProbabilityShareType.LOCKED_IN], params),
	},
};

/** Resolve per-event admin template, or fall back to the shared default. */
export function resolveProbabilityShareDescription(
	type: ProbabilityShareType,
	params: Record<string, string>,
	perEventTemplate?: string | null
): string {
	const template =
		typeof perEventTemplate === 'string' && perEventTemplate.trim()
			? perEventTemplate
			: PROBABILITY_SHARE_TEXT_TEMPLATES[type];
	return interpolateTemplate(template, params);
}
